/* eslint-disable no-undef */
import React from "react";
import PropTypes from "prop-types";
import Section from "../common/Section";
import Form from "../common/Form";
import * as domainConstants from '../../constants/DomainConstants';
import * as types from "../../constants/ComponentConstants";
import Row from "../common/Row";
import TextInput from "../common/TextInput";
import SelectInput from "../common/SelectInput";
import Dropdown from "../common/Dropdown";
import Button from "../common/Button";
import Fieldset from "../common/Fieldset";
import Tooltip from "../common/Tooltip";
import ValidationGroup from "../common/ValidationGroup";
import Map from "../common/map/Map";
import Markers from "../common/map/Markers";

const InfrastructuurInDeBuurtDetailForm = (props) => {
    const {
        color,
        model,
        isNew,
        isSpakki,
        onChange,
        soortenInfrastructuur,
        gemeenten,
        postcodes,
        mapKey,
        mapEditMode,
        mapCenter,
        mapNewCoords,
        onSave,
        onCancel,
        onReplacePoint,
        onSaveNewPoint,
        onCancelReplace,
        onGetGeoCoordinates,
        errors,
        maxMapFeaturesToLoad,
        osmBaseLayerUrl,
        onMarkerDragEnd,
        validationMessageType
    } = props;

    const formTitle = isNew ? "Voeg ontbrekende sportinfrastructuren in de buurt toe" : "Wijzig sportinfrastructuur " + model.naam;

    const soortenInfrastructuurList = soortenInfrastructuur.filter(i => i.id != domainConstants.ANDERE_INFRASTRUCTUUR_GUID).map((soortInfrastructuurObject) => {
        return {
            value: soortInfrastructuurObject.id,
            label: soortInfrastructuurObject.description,
            text: soortInfrastructuurObject.description
        };
    });
    const hasCoordinates = mapNewCoords != null;

    const markersToShow = hasCoordinates ? [{
        lat: parseFloat(mapNewCoords.lat),
        long: parseFloat(mapNewCoords.lng),
        size: 'x-large',
        color: types.COLOR_BLUE,
        draggable: mapEditMode,
        onDragEnd: onMarkerDragEnd
    }] : null;

    const mijnProjectMarkers = hasCoordinates ? <Markers markersToShow={markersToShow} /> : null;

    const wijzigMapTooltip = "Het is zeer belangrijk dat de aangevraagde infrastructuur aangeduid is exact op de plaats waar deze zal gerealiseerd worden. Dit is het midden van de sportinfrastructuur.";

    return (<Section title={"Vul het antwoord op onderstaande vragen in"} color={color}>
        <Form
            title={formTitle}
            name={"InfrastructuurDetail"}
            leftButtonLabel={"Annuleer"}
            onLeftButtonClick={onCancel}
            leftButtonDisabled={mapEditMode}
            rightButtonLabel={"Bewaar"}
            onRightButtonClick={onSave}
            rightButtonDisabled={mapEditMode}>
            <Fieldset>
                <Row>
                    <TextInput
                        name={"naam"}
                        label={"Naam"}
                        value={model.naam}
                        onChange={onChange}
                        maxLength={300}
                        validationMessage={errors ? errors.naam : ''}
                        validationMessageType={validationMessageType}
                        disabled={isSpakki}
                        size={12}
                    />
                </Row>
                <Row>
                    <SelectInput
                        name={"soortInfrastructuurId"}
                        label={"Soort infrastructuur"}
                        onChange={onChange}
                        value={model.soortInfrastructuurId}
                        validationMessage={errors ? errors.soortInfrastructuurId : ''}
                        validationMessageType={validationMessageType}
                        disabled={isSpakki}
                        size={model.soortInfrastructuurId != domainConstants.ANDERE_INFRASTRUCTUUR_GUID ? 12 : 6}
                        items={soortenInfrastructuurList}
                    />
                    {model.soortInfrastructuurId != domainConstants.ANDERE_INFRASTRUCTUUR_GUID ||
                        <TextInput
                            name={"andereInfrastructuur"}
                            label={"Andere infrastructuur"}
                            value={model.andereInfrastructuur}
                            onChange={onChange}
                            maxLength={200}
                            validationMessage={errors ? errors.andereInfrastructuur : ''}
                            validationMessageType={validationMessageType}
                            size={6}
                        />
                    }
                </Row>
                <Row>
                    <TextInput
                        name={"straatEnHuisnummer"}
                        label={"Straat en huisnummer"}
                        value={model.straatEnHuisnummer}
                        onChange={onChange}
                        maxLength={200}
                        validationMessage={errors ? errors.straatEnHuisnummer : ''}
                        validationMessageType={validationMessageType}
                        size={12}
                    />
                </Row>
                <Row>
                    <Dropdown
                        name={"postcode"}
                        label={"Postcode"}
                        value={model.postcode}
                        onChange={onChange}
                        validationMessage={errors ? errors.postcode : ''}
                        validationMessageType={validationMessageType}
                        size={4}
                        items={postcodes}
                        noResultsMessage="Tik (2 cijfers) en zoek"
                        disabled={false}
                    />
                    <Dropdown
                        name={"gemeente"}
                        label={"Gemeente"}
                        onChange={onChange}
                        value={model.gemeente}
                        size={8}
                        items={gemeenten}
                        validationMessage={errors ? errors.gemeente : ''}
                        validationMessageType={validationMessageType}
                        disabled={false}
                    />
                </Row>
                <Row>
                    <Button
                        onClick={onGetGeoCoordinates}
                        text={"Positioneer infrastructuur op de kaart"}
                        disabled={mapEditMode}
                        className={"o-col-4"}
                        style={{ marginLeft: '0.8333%', marginRight: '0.8333%' }}
                    />
                    <ValidationGroup cols={8} colsBefore={4} errors={errors ? errors.hasCoordinatenLigging : undefined} >
                        <TextInput
                            label="breedtegraad"
                            disabled size={errors && errors.hasCoordinatenLigging ? 6 : 4}
                            value={model.breedtegraad}
                            name="breedtegraad" />
                        <TextInput
                            label="lengtegraad"
                            disabled size={errors && errors.hasCoordinatenLigging ? 6 : 4}
                            value={model.lengtegraad}
                            name="lengtegraad" />
                    </ValidationGroup>

                </Row>
                {hasCoordinates ?
                    <Row>
                        <Map
                            mapName={mapKey}
                            maxMapFeaturesToLoad={maxMapFeaturesToLoad}
                            baseLayerUrl={osmBaseLayerUrl}
                            baseLayerAttribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors, Tiles courtesy of <a href="https://geo6.be/">GEO-6</a>'
                            children={mijnProjectMarkers}
                            zoom={15}
                            showEmptyMap
                            hideLegende
                            onlyBaseLayers
                            customCenter={mapCenter}
                        />
                    </Row>
                    : null}
                {hasCoordinates ?
                    <Row>
                        <br />
                        {mapEditMode === false ?
                            <span>
                                <Button
                                    onClick={onReplacePoint}
                                    text={'Wijzig de ligging op de kaart'}
                                />
                                <Tooltip
                                    text={wijzigMapTooltip}
                                    iconColor={types.COLOR_BLUE_DARK}
                                    tooltipType={types.TOOLTIP_INFO}
                                    windowWidth={35}
                                    windowAlignRight={false} />
                            </span>
                            : ''}
                        {mapEditMode === true ?
                            <span>
                                <Button
                                    onClick={onSaveNewPoint}
                                    text={'Bewaar locatie'}
                                />
                                <Button
                                    onClick={onCancelReplace}
                                    text={'Annuleer'}
                                />
                            </span>
                            : ''}
                    </Row>
                    : null}
            </Fieldset>
        </Form>
    </Section >);
};

InfrastructuurInDeBuurtDetailForm.propTypes = {
    color: PropTypes.string.isRequired,
    model: PropTypes.object.isRequired,
    isNew: PropTypes.bool,
    isSpakki: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    soortenInfrastructuur: PropTypes.array.isRequired,
    gemeenten: PropTypes.array.isRequired,
    postcodes: PropTypes.array.isRequired,
    mapKey: PropTypes.string.isRequired,
    mapEditMode: PropTypes.bool.isRequired,
    mapCenter: PropTypes.object.isRequired,
    infrastructuurCoords: PropTypes.object.isRequired,
    mapNewCoords: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onReplacePoint: PropTypes.func.isRequired,
    onSaveNewPoint: PropTypes.func.isRequired,
    onCancelReplace: PropTypes.func.isRequired,
    onGetGeoCoordinates: PropTypes.func.isRequired,
    errors: PropTypes.array.isRequired,
    maxMapFeaturesToLoad: PropTypes.string,
    osmBaseLayerUrl: PropTypes.string,
    onMarkerDragEnd: PropTypes.func,
    validationMessageType: PropTypes.string
};

export default InfrastructuurInDeBuurtDetailForm;